/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { BreadcrumbModel, BreadcrumbV2Model } from '@/api/types/browse-search-types';
import type { Url } from '../../../../next-types';

export type IItem = {
  label?: string;
  url?: Url | string;
  pageType?: string;
  displayName?: string;
};

export type IItemV2 = {
  label?: string;
  canonicalUrl?: string;
  canonicalPath?: string;
  pageType?: string;
  categoryName?: string;
};

export type BreadcrumbItemType = IItem & IItemV2;

export const isBreadcrumbModel = (
  breadcrumb: BreadcrumbItemType | BreadcrumbModel | BreadcrumbV2Model,
): breadcrumb is BreadcrumbModel => {
  return Boolean(breadcrumb && 'canonicalPath' in breadcrumb);
};
